import apiUrl from "./apiUrl";

const shelfImageMap = {
  dairy_shelf_1: `${apiUrl}/shelf-images/dairy-shelf-1.jpg`,
};

export default shelfImageMap;
